module.exports = __webpack_public_path__ + "img/culture_img1.ae2e885c.png";